<div class="vsp-table-cell-container">
   <div
      class="type-set d-flex align-items-center justify-content-center"
      [ngClass]="{
         'type-1': day().type == 1,
         'type-2': day().type == 2,
         'type-3': day().type == 3,
         'type-4': day().type == 4,
         'type-5': day().type == 5,
         'type-6': day().type == 6,
         'type-7': day().type == 7,
         'type-8': day().type == 8,
         closed: service.week().isDayClosed[day().weekday],
      }"
      *ngIf="day().type > 0 || service.week().isDayClosed[day().weekday]">
      <div *ngIf="service.week().isDayClosed[day().weekday]">Closed</div>
      <div
         class="text-center"
         *ngIf="!service.week().isDayClosed[day().weekday]">
         <div>{{ dayTypes[day().type] }}</div>
         @for (shift of day().shifts; track $index) {
            <div style="font-size: 11px; line-height: 15px; margin-top: 5px">
               @if (!isTimelessShiftType(shift.type)) {
                  {{ shift.startTime | vspTime }}-{{ shift.endTime | vspTime }}
               }
               <i>{{ shiftTypes[shift.type] }}</i>
            </div>
         }
      </div>
   </div>
   <div
      *ngIf="!service.week().isDayClosed[day().weekday] && service.week()?.status <= 1"
      [ngClass]="{ 'buttons-notset': day().type == 0 }"
      class="buttons d-flex align-items-center justify-content-center">
      <span (click)="service.openDayDialog(day(), doctor(), true)"><i class="fa fa-plus"></i></span>
      <span (click)="service.openDayDialog(day(), doctor(), false)"><i class="fa fa-minus"></i></span>
      <span
         *ngIf="!!day().type"
         style="position: absolute; bottom: 9px; right: 4px"
         (click)="service.clearDay(doctor(), day())">
         <i
            style="color: #000000"
            class="fa fa-trash-can"></i>
      </span>
   </div>
</div>
